import { Injectable, inject } from '@angular/core';
import {environment} from '../../../../environments/environment';
import {Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {GrupoAdModel} from '../model/grupo/grupoAd-model';

@Injectable({
  providedIn: 'root'
})
export class GrupoAdService {

  private readonly http = inject(HttpClient);

  urlBase = `${environment.urlBase}/grupo-ad`;



  buscarConexaoAdPorGrupo(): Observable<GrupoAdModel> {
    return this.http.get<GrupoAdModel>(this.urlBase)
  }

  verificarConexaoAd(ad: GrupoAdModel): Observable<boolean> {
    return this.http.post<boolean>(`${this.urlBase}/verificar-conexao`, ad);
  }

  salvarConexaoAd(grupoAd: GrupoAdModel){
    return this.http.post<boolean>(`${this.urlBase}/salvar-conexao`, grupoAd);
  }

}
